



































import { Component, Mixins, Prop } from "vue-property-decorator";
import RequestedDocumentProcessor from "./helpers/RequestedDocumentProcessor.vue";
import { FixedLoading } from "../system";
import { IRestrictions } from "./editor";
import { NewDocumentEditor } from "./editors/sign";
import { DocumentEditViewMixin } from "./mixins";

@Component({
  components: {
    FixedLoading,
    NewDocumentEditor,
    RequestedDocumentProcessor,
  },
})
export default class NewDocumentSignView extends Mixins(DocumentEditViewMixin) {
  @Prop()
  folderId: string;

  @Prop()
  defaultFormatTabName: string;

  @Prop()
  documentKindIds: number[];

  @Prop()
  formatId: number;

  @Prop()
  formatIds: number[];

  @Prop({ default: null })
  formatName: string;

  @Prop()
  chainedFormatIds: number[];

  @Prop()
  institutionNo: string;

  @Prop()
  regionalInstitutionNo: string;

  @Prop()
  hisInfoGetterParameter: string;

  @Prop()
  systemKey: string;

  @Prop()
  linkKey: string;

  @Prop()
  orderNo: string;

  @Prop()
  postRegistrationProcess: (id: number) => Promise<void>;

  @Prop({ default: false })
  shouldValidateExistingLinkedDocument: boolean;

  $refs!: {
    processor: RequestedDocumentProcessor;
  };

  get restrictions(): IRestrictions {
    return {
      tools: {
        createdReport: {
          isDisabled: true,
        },
        claio: {
          isDisabled: true,
        },
        claioSchema: {
          isDisabled: true,
        },
        externalImage: {
          isDisabled: true,
        },
        ocojo: {
          isDisabled: true,
        },
      },
      pageList: {
        isDisabled: true,
      },
    };
  }

  async validateSelectedFormat(format: any): Promise<boolean> {
    return this.validateFormat(format, false);
  }

  validateSelectedFormatWriteMethod(format: any): boolean {
    return this.validateFormatWriteMethod(format, false);
  }
}
